import ApiService from '../api.services';

const OccurrenceService = {
  list: async function() {
    try {
      const response = await ApiService.get('/api/occurrences');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function(id) {
    try {
      const response = await ApiService.get(`/api/occurrences/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async function(form) {
    try {
      const data = {
        occurrence: form,
      };
      const res = await ApiService.post('/api/occurrences', data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function(id, form) {
    const data = {
      occurrence: form,
    };
    try {
      const response = await ApiService.put(`/api/occurrences/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  delete: async function(id) {
    try {
      const response = await ApiService.delete(`/api/occurrences/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default OccurrenceService;

export { OccurrenceService };
